<template>
  <v-card style="height: 100%">
    <project-flow-navigation-toolbar
      :title="apartmentOrientationName"
    ></project-flow-navigation-toolbar>

    <v-toolbar dark dense>
      <v-tabs v-model="tab">
        <v-tab href="#details"> Details </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items
      style="height: calc(100% - 112px); position: relative"
      v-model="tab"
    >
      <v-tab-item style="height: 100%" value="details">
        <v-card class="full-height-card">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  class="mt-5"
                  dense
                  v-model="apartmentOrientation.name"
                  label="Name"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-spacer />
          <v-card-actions>
            <v-btn color="red darken-1" @click="deleteApartmentOrientation"
              >Delete</v-btn
            >
            <v-spacer></v-spacer>
            <v-fade-transition>
              <span v-if="changeDetected" class="caption amber--text d-flex align-center mr-2">
                <v-icon x-small color="amber" class="mr-1">mdi-circle-medium</v-icon>Unsaved changes
              </span>
            </v-fade-transition>
            <v-btn v-if="changeDetected" text @click="discard">Discard</v-btn>
            <v-btn
              color="blue darken-1"
              :disabled="saveButtonDisabled"
              @click="save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ProjectFlowNavigationToolbar from '../../components/AppBar/ProjectFlowNavigationToolbar'
import Enums from '../../helpers/Enums'
import 'brace'
import 'brace/theme/tomorrow_night_bright'
import VFormBase from 'vuetify-form-base'
import { mapState } from 'vuex'

export default {
  name: 'ApartmentExplore',
  props: {},
  components: {
    ProjectFlowNavigationToolbar
  },
  data: function() {
    return {
      pois: [],
      apartmentOrientation: {},
      apartmentOrientationId: null,
      title: '',
      tab: 'details',
      changeDetected: false,
      myModel: {},
      mySchema: {}
    }
  },
  computed: {
    ...mapState('ApartmentOrientationStore', ['selectedApartmentOrientation']),
    apartmentOrientationName: function() {
      return this.selectedApartmentOrientation
        ? this.selectedApartmentOrientation.name
        : ''
    },
    saveButtonDisabled: function() {
      return !this.changeDetected
    }
  },
  methods: {
    getData: async function() {
      if (this.apartmentOrientationId) {
        await this.$store.dispatch(
          'ApartmentOrientationStore/setSelectedApartmentOrientation',
          this.apartmentOrientationId,
          { root: true }
        )
        this.apartmentOrientation = JSON.parse(
          JSON.stringify(this.selectedApartmentOrientation)
        )
        if (
          this.selectedApartmentOrientation.properties &&
          Object.prototype.hasOwnProperty.call(
            this.selectedApartmentOrientation.properties,
            'apartmentFieldsSchema'
          )
        ) {
          this.mySchema = this.selectedApartmentOrientation.properties[
            'apartmentFieldsSchema'
          ]
        }
      }
    },
    save: async function() {
      await this.$store.dispatch(
        'ApartmentOrientationStore/updateApartmentOrientation',
        this.apartmentOrientation
      )
      await this.getData()
      this.apartmentOrientation = JSON.parse(
        JSON.stringify(this.selectedApartmentOrientation)
      )
      this.changeDetected = false
    },
    discard() {
      this.apartmentOrientation = JSON.parse(JSON.stringify(this.selectedApartmentOrientation))
      this.changeDetected = false
    },
    deleteApartmentOrientation: async function() {
      this.$confirm({
        title: 'Delete Apartment Orientation',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
        .then(y => {
          this.$store
            .dispatch(
              'ApartmentOrientationStore/deleteApartmentOrientation',
              this.$route.params.apartmentOrientationId
            )
            .then(
              () => {
                this.$router.go(-1)
                this.$emit('deleted')
              },
              err => {
                this.$store.dispatch(
                  'NotificationStore/add',
                  {
                    type: 'error',
                    message: err.message
                  },
                  { root: true }
                )
              }
            )
        })
        .catch(n => {
          console.log('NO')
        })
    },
    handleInput(val) {
      console.log(val)
    }
  },
  created: function() {},
  mounted: function() {},
  watch: {
    apartmentOrientation: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        if (JSON.stringify(before) !== '{}') {
          this.changeDetected =
            JSON.stringify(this.apartmentOrientation) !==
            JSON.stringify(this.selectedApartmentOrientation)
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.apartmentOrientationId = to.params.apartmentOrientationId
      vm.getData()
    })
  },
  async beforeRouteUpdate(to, from, next) {
    this.apartmentOrientationId = to.params.apartmentOrientationId
    await this.getData()
    next()
  }
}
</script>

<style scoped></style>
